module.exports = __webpack_public_path__ + "assets/yingyezhizhao.c3130d16.svg";